import { render, staticRenderFns } from "./DebitCard.vue?vue&type=template&id=d22ef22c&scoped=true&"
import script from "./DebitCard.vue?vue&type=script&lang=js&"
export * from "./DebitCard.vue?vue&type=script&lang=js&"
import style0 from "./DebitCard.vue?vue&type=style&index=0&id=d22ef22c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d22ef22c",
  null
  
)

export default component.exports